import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FeathersService } from '../feathers.service'
import { SrEventListItem, SrEventListResponse, SrEventListModel } from '../../models/sr-event-list.model'

@Injectable({
  providedIn: 'root',
})
export class SrEventListService {
  constructor(private feathers: FeathersService) {}

  getSrEvents(query?: any): Observable<SrEventListItem[]> {
    return new Observable((observer) => {
      console.log('Calling SrEventListService with service name:', SrEventListModel.serviceName)

      // Pass an empty query object to ensure proper service call
      this.feathers
        .service(SrEventListModel.serviceName)
        .find({ query: query || {} })
        .then((response) => {
          console.log('SrEventListService response:', response)
          observer.next(response)
          observer.complete()
        })
        .catch((error) => {
          console.error('SrEventListService error:', error)
          observer.error(error)
        })
    })
  }

  async getSrEvent(id: number) {
    return await this.feathers.service(SrEventListModel.serviceName).get(id)
  }
}
